import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'success' | 'warn' | 'danger' | 'pro';

export interface BadgeProps {
  children?: ReactNode;
  tone?: BadgeTone;
  pill?: boolean;
}

interface ToneStyle {
  color: string;
  bg: string;
  border: string;
}

const TONES: Record<BadgeTone, ToneStyle> = {
  neutral: { color: 'var(--text-2)', bg: 'var(--surface-2)', border: '1px solid var(--line)' },
  success: { color: 'var(--success)', bg: 'var(--success-tint)', border: '1px solid var(--success-line)' },
  warn: { color: 'var(--amber-ink)', bg: 'var(--amber-tint)', border: '1px solid var(--amber-line)' },
  danger: { color: 'var(--danger)', bg: 'var(--danger-tint)', border: '1px solid var(--danger-line)' },
  pro: { color: 'var(--on-amber)', bg: 'var(--amber)', border: '1px solid transparent' },
};

export function Badge({ children, tone = 'neutral', pill = true }: BadgeProps) {
  const t = TONES[tone];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontFamily: 'var(--font-mono)',
        fontSize: 9.5,
        fontWeight: 600,
        letterSpacing: '.06em',
        color: t.color,
        background: t.bg,
        border: t.border,
        borderRadius: pill ? 999 : 6,
        padding: '3px 9px',
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
      }}
    >
      {children}
    </span>
  );
}
